import React, { useState, useEffect, createContext, useContext, useCallback } from 'react';
import {
  getUser,
  signIn as sendSignInRequest,
  signOut as sendSignOutRequest,
  signInNewAccount as sendSignInNewAccountRequest,
  refreshSession as sendRefreshSessionRequest
} from '../api/auth';
import AWS from 'aws-sdk';
import { setS3CognitoUserCredentials } from '../api/s3'

function AuthProvider(props) {
  const [user, setUser] = useState();
  const [refreshToken, setRefreshToken] = useState(null);
  const [userCredentials, setUserCredentials] = useState();
  const [loading, setLoading] = useState(true);
  const [userCtx, setUserCtx] = useState({});

  useEffect(() => {
    (async function () {
      const result = await getUser();
      if (result.isOk) {
        setUser(result.user);
      }
      setLoading(false);
    })();
  }, []);

  useEffect(() => {
    if (user !== undefined && user !== null && user.signInUserSession) {
      setRefreshToken(user.signInUserSession.getRefreshToken());
      let creds = new AWS.CognitoIdentityCredentials({
        IdentityPoolId: 'us-east-1:5c016be5-5a95-43b6-9b9c-d7b6a8068b72',
        Logins: {
          'cognito-idp.us-east-1.amazonaws.com/us-east-1_PWGdvdE3P': user.signInUserSession.getIdToken().getJwtToken(),
        },
      });
      creds.get((err) => {
        if (err) {
          console.log(err);
          return;
        }
        setUserCredentials(creds);
        setS3CognitoUserCredentials(creds, user.signInUserSession.getIdToken().payload.sub);
      });
    }
  }, [user]);

  useEffect(() => {
    if (user !== undefined && user !== null && user.signInUserSession === null) {
      refreshSession();
    }
  }, [user && user.signInUserSession]);

  const signIn = useCallback(async (email, password) => {
    const result = await sendSignInRequest(email, password);
    if (result.isOk) {
      setUser(result.user);
    }

    return result;
  }, []);

  const signInNewAccount = useCallback(async () => {
    const result = await sendSignInNewAccountRequest();
    if (result.isOk) {
      setUser(result.user);
    }

    return result;
  }, []);

  const signOut = useCallback(async () => {
    const result = await sendSignOutRequest();
    if (result.isOk) {
      setUser(undefined);
    }
    return result;
  }, []);

  const refreshSession = useCallback(async () => {
    const result = await sendRefreshSessionRequest(refreshToken);
    if (result.isOk) {
      result.user.signInUserSession = result.session;
      setUser(result.user);
    } else {
      setUser(undefined);
    }
    return result;
  }, [refreshToken]);

  const getUserContext = useCallback(() => {
    return userCtx;
  }, [userCtx]);

  const setUserContext = useCallback((context) => {
    setUserCtx(context);
  }, [setUserCtx]);


  return (
    <AuthContext.Provider value={{ user, cognitoUserCredentials: userCredentials, signIn, signInNewAccount,
      signOut, loading, refreshSession, getUserContext, setUserContext }} {...props} />
  );
}

const AuthContext = createContext({ loading: false });
const useAuth = () => useContext(AuthContext);

export { AuthProvider, useAuth }
